import { Theme, ThemeOptions, createTheme } from "@mui/material";
import { deDE as datePickerDE } from "@mui/x-date-pickers/locales";
import { breakpoints } from "./breakpoints";
import { components } from "./components";
import { palette } from "./palette";
import { typography } from "./typography";

const themeOptions: ThemeOptions = {
  typography,
  palette,
  components,
  ...datePickerDE.components,
  breakpoints,
};

export const theme: Theme = createTheme(themeOptions);

export default theme;
